import { http, HttpResponse } from "msw";
import { gCoinMeBalance, gCoinMePurchase, gCoinMeUsages, gCoinMeUsagesDetail, generateRandomPCCafeData, paymentInvoice } from "./data/gCoinMe";
import { GCoinMeUsagesDetailRaw } from "../model/gCoinMeModel";
import { taxMeHistoryData } from "./data/taxMe";
import { refundMeGcoinRefundablelistData, refundMeGcoinRefundlistDataList } from "./data/refund";
import { coupons } from "./data/coupon";
import { about } from "./data/about";
import { paymentInfoData, paymentOrderData, subscriptionOrderData, virtualBankData } from "./data/payment";
import { LoginInfoRawType } from "@features/auth/model/loginModel";

export default [
  http.get("/api-proxy/gcoin/me/balance", async ({ request, params, cookies }) => {
    return HttpResponse.json(gCoinMeBalance);
    // return HttpResponse.json(
    //   {
    //     errorMessage: "Missing session",
    //   },
    //   { status: 404 },
    // );
  }),

  http.get("/api-proxy/gcoin/me/purchases", async ({ request, params, cookies }) => {
    const url = new URL(request.url);
    const startDate = url.searchParams.get("startDate");
    const endDate = url.searchParams.get("endDate");

    let result;

    if (startDate && endDate) {
      result = HttpResponse.json(gCoinMePurchase?.filter((item) => item.chargeDate >= startDate && item.chargeDate <= endDate));
    } else {
      result = HttpResponse.json(gCoinMePurchase);
    }

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(result);
      }, 1000);
    });
  }),

  http.get("/api-proxy/gcoin/me/usages", async ({ request, params, cookies }) => {
    const url = new URL(request.url);
    const startDate = url.searchParams.get("startDate");
    const endDate = url.searchParams.get("endDate");
    const index = url.searchParams.get("index");
    const size = url.searchParams.get("size");

    // let data = gCoinMeUsages

    // if (startDate && endDate) {
    //   data = gCoinMeUsages?.filter((item) => JSON.parse(item.withdrawalData).started >= startDate && JSON.parse(item.withdrawalData).stopped <= endDate)
    // } else {
    //   data = gCoinMeUsages
    // }

    // const data = gCoinMeUsages.data.slice((Number(index) - 1) * Number(size), Number(index) * Number(size));

    // return HttpResponse.json(
    //   {
    //     errorMessage: "Missing session",
    //   },
    //   { status: 404 },
    // );

    const result = HttpResponse.json(gCoinMeUsages);

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(result);
      }, 1000);
    });
  }),

  /**
   * 내 G코인 사용 상세 조회
   * [GET] /gcoin/me/usages/detail?startDate={startDate}&endDate={endDate}&index={index}&size={size}
   */
  http.get("/api-proxy/gcoin/me/usages/detail", async ({ request, params, cookies }) => {
    const url = new URL(request.url);
    const startDate = url.searchParams.get("startDate");
    const endDate = url.searchParams.get("endDate");

    let result;

    if (resultMap.has(JSON.stringify({ startDate, endDate }))) {
      result = resultMap.get(JSON.stringify({ startDate, endDate }));
    } else {
      result = generateRandomPCCafeData(100);
      resultMap.set(JSON.stringify({ startDate, endDate }), result);
    }

    // console.log(resultMap);

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(result));
      }, 1000);
    });
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(
          HttpResponse.json(
            {
              errorCode: "TEST",
              message: "Missing session",
            },
            { status: 404 },
          ),
        );
      }, 1000);
    });
  }),

  /**
   * 로그인한 계정의 세금 계산서 조회
   * [GET] /tax/me/history
   */
  http.get("/api-proxy/tax/me/history", async ({ request, params, cookies }) => {
    // return HttpResponse.json(taxMeHistoryData);

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(taxMeHistoryData));
      }, 1000);
    });
    return HttpResponse.json(null);
    return HttpResponse.json(
      {
        errorMessage: "Missing session",
      },
      { status: 404 },
    );
  }),

  /**
   * Refund 대상 목록
   * [GET] /refund/me/gcoin/refundablelist
   */
  http.get("/api-proxy/refund/me/gcoin/refundablelist", async ({ request, params, cookies }) => {
    // return HttpResponse.json(refundMeGcoinRefundablelistData);

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(refundMeGcoinRefundablelistData));
      }, 1000);
    });
  }),

  /**
   * Refund 목록 (환불 신청한 목록인거 같음)
   * [GET] /refund/me/gcoin/refundlist
   */
  http.get("/api-proxy/refund/me/gcoin/refundlist", async ({ request, params, cookies }) => {
    // return HttpResponse.json(refundMeGcoinRefundlistData);

    const url = new URL(request.url);
    const startDate = url.searchParams.get("startDate");
    const endDate = url.searchParams.get("endDate");
    const page = url.searchParams.get("page");
    const size = url.searchParams.get("size");

    if (page !== "1") {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(
            HttpResponse.json(
              {
                errorCode: "TEST",
                message: "Missing session",
              },
              { status: 404 },
            ),
          );
        }, 1000);
      });
    }
    // let data = gCoinMeUsages

    // if (startDate && endDate) {
    //   data = gCoinMeUsages?.filter((item) => JSON.parse(item.withdrawalData).started >= startDate && JSON.parse(item.withdrawalData).stopped <= endDate)
    // } else {
    //   data = gCoinMeUsages
    // }

    const refunds = refundMeGcoinRefundlistDataList.slice((Number(page) - 1) * Number(size), Number(page) * Number(size));
    const totalCount = refundMeGcoinRefundlistDataList.length;
    const result = HttpResponse.json({ totalCount, refunds });
    console.log(refunds);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(result);
      }, 1000);
    });
  }),

  /**
   * Refund 취소(삭제)
   * [DELETE] /refund/me/refundid/{refundReceptionId}/delete
   */
  http.delete("/api-proxy/refund/me/refundid/:refundReceptionId/delete", async ({ request, params, cookies }) => {
    return HttpResponse.json(null);
  }),

  /**
   * Refund gcoin 환불 - 카드 결제 취소
   * [POST] /refund/me/paymentid/{paymentId}/cardcancel
   */
  http.post("/api-proxy/refund/me/paymentid/:paymentId/cardcancel", async ({ request, params, cookies }) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(null));
      }, 1000);
    });
  }),

  /**
   * Refund gcoin 환불 - 송금 이체
   * [POST} /refund/me/regist
   */
  http.post("/api-proxy/refund/me/regist", async ({ request, params, cookies }) => {
    // return HttpResponse.json(null);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(null));
      }, 4000);
    });
  }),

  /**
   * Refund 환불 계좌 체크
   * [POST] /refund/checkaccount
   */
  http.post("/api-proxy/refund/checkaccount", async ({ request, params, cookies }) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(null));
      }, 1000);
    });
  }),

  /**
   * Refund gcoin 환불 - 송금 이체
   * [POST} /refund/me/regist
   */
  http.post("/api-proxy/refund/me/regist", async ({ request, params, cookies }) => {
    return HttpResponse.json(null);
  }),

  /**
   * 쿠폰 등록
   * [POST] /coupons {body: CouponsRegistBody}
   */
  http.post("/api-proxy/coupons", async ({ request, params, cookies }) => {
    // return HttpResponse.json(null);

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(null));
      }, 1000);
    });
  }),

  /**
   * 쿠폰 사용 내역 조회 (API 문서에 closingDate 중복)
   * [GET] /coupons
   */
  http.get("/api-proxy/coupons", async ({ request, params, cookies }) => {
    return HttpResponse.json(coupons);
  }),

  /**
   * 콘티 정보 가져 오기 alias=about
   * [GET] /about
   */
  http.get("/conti/getContent", async ({ request, params, cookies }) => {
    return HttpResponse.json(about);
  }),

  /**
   * 가상계좌 조회
   * [GET] /payment/virtual-bank
   */
  http.get("/api-proxy/payment/virtual-bank", async ({ request, params, cookies }) => {
    // return HttpResponse.json(virtualBankRawSchema);
    // const data = { enabled: true, bankName: "기업은행", virtualBankAccountNumber: "08205527997844" };
    const data = { enabled: false, bankName: null, virtualBankAccountNumber: null };
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(data));
      }, 1000);
    });
  }),

  /**
   * 일반 결제 주문서 요청
   * [POST] /payment/order
   */
  http.post("/api-proxy/payment/order", async ({ request, params, cookies }) => {
    const data = {
      orderKey: "2025062617065122610",
      paymentUrl: "https://orderform.sb.plaync.com",
    };
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(data));
      }, 1000);
    });
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(
          HttpResponse.json(
            {
              errorMessage: "Missing session",
            },
            { status: 500 },
          ),
        );
      }, 1000);
    });
  }),

  /**
   * 정기 결제 주문서 요청
   * [POST] /payment/subscription-order
   */
  http.post("/api-proxy/payment/subscription-order", async ({ request, params, cookies }) => {
    const data = {
      orderKey: "2025062617065122610",
      paymentUrl: "https://orderform.sb.plaync.com",
    };
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(data));
      }, 1000);
    });
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(
          HttpResponse.json(
            {
              errorMessage: "Missing session",
            },
            { status: 500 },
          ),
        );
      }, 1000);
    });
  }),

  /**
   * 결제 정보 조회
   * [GET] /payment/info
   */
  http.get("/api-proxy/payment/info", async ({ request, params, cookies }) => {
    // return HttpResponse.json(
    //   {
    //     errorMessage: "Missing session",
    //   },
    //   { status: 404 },
    // );

    // return HttpResponse.json(paymentInfoData);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(paymentInfoData));
      }, 1000);
    });
  }),

  /**
   * 정기 결제 해지
   * [POST] /payment/subscription/cancel
   */
  http.post("/api-proxy/payment/subscription/cancel", async ({ request, params, cookies }) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(null));
      }, 1000);
    });
  }),

  /**
   * 결제 매출 전표 조회
   * [GET] /payment/invoice
   */
  http.get("/api-proxy/payment/invoice", async ({ request, params, cookies }) => {
    // return HttpResponse.json(paymentInvoice);

    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve(
    //       HttpResponse.json(
    //         {
    //           errorCode: "TEST",
    //           message: "Missing session",
    //         },
    //         { status: 500 },
    //       ),
    //     );
    //   }, 1000);
    // });

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(paymentInvoice));
      }, 10000);
    });
  }),

  http.get("/api-proxy/account/login-info", async ({ request, params, cookies }) => {
    return HttpResponse.json(loginInfoData);
  }),

  /**
   * 자동 결제 연락처 정보 조회
   * [GET] /payment/subscription/contact
   */
  http.get("/api-proxy/payment/subscription/contact", async ({ request, params, cookies }) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json({ email: "test@test.com", phone: "010-12345678" }));
      }, 1000);
    });
  }),

  /**
   * 자동 결제 연락처 정보 변경
   * [POST] /payment/subscription/contact
   */
  http.post("/api-proxy/payment/subscription/contact", async ({ request, params, cookies }) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(null));
      }, 1000);
    });
  }),

  /**
   * IP 세션(실행중 게임) 존재 여부
   * [GET] /ipmanage/me/session/ips
   */
  http.get("/api-proxy/ipmanage/me/session/ips", async ({ request, params, cookies }) => {
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve(
    //       HttpResponse.json(
    //         {
    //           errorCode: "TEST",
    //           message: "Missing session",
    //         },
    //         { status: 500 },
    //       ),
    //     );
    //   }, 1000);
    // });
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json({ existSession: true, iCafeId: "1234567890", reason: "test" }));
      }, 1000);
    });
  }),
];

const resultMap = new Map<any, GCoinMeUsagesDetailRaw>();

const loginInfoData: LoginInfoRawType = {
  ip: "127.0.0.1",
  ncfzUserInfo: {
    login: true,
    companyStateCode: 1,
    statusCode: 1,
    lastAccessedTime: 1717171717171,
  },
  playncUserInfo: {
    login: false,
    userId: "test",
    nickName: "test",
    account: "test",
  },
  ncfzUserStatusCode: "PLAYNC_USER_2",
};
